// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Browser, type OpenOptions } from "@capacitor/browser";

/**
 * Opens a URL in the browser with consistent styling
 *
 * @param url - The URL to open in the browser
 * @returns A promise that resolves when the browser is opened
 */
export async function openBrowser(url: string, options?: Partial<OpenOptions>) {
  await Browser.open({
    url,
    windowName: "_blank",
    presentationStyle: "popover",
    ...options,
  });
}
